import has from "lodash/has";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Booking, BookingCategory } from "PFCore/types";

const PLACEHOLDER_CATEGORY_KEY = "placeholder";

export const usePlaceholderBooking = () => {
  const { getBookingCategory } = useBookingCategories();

  const isBookingPlaceholder = (booking: Booking | undefined) => {
    if (!booking) {
      return false;
    }

    const category = getBookingCategory(booking.booking_category_id);

    return category?.key === PLACEHOLDER_CATEGORY_KEY;
  };

  return {
    isBookingPlaceholder,
    isCategoryPlaceholder: (category: BookingCategory | undefined) =>
      category?.key === PLACEHOLDER_CATEGORY_KEY,
    checkBookingRequiresApproval: (booking: Booking | undefined) => {
      if (!booking) {
        return false;
      }

      const isPlaceholder = isBookingPlaceholder(booking);
      const isReassignedFrom = has(booking.metadata, "placeholder_booking_id");

      return isPlaceholder || isReassignedFrom;
    }
  };
};
